function StepMeta({ label, detail }) {
  return (
    <>
      <span className="step-indicator__label">{label}</span>
      {detail ? <span className="step-indicator__detail">{detail}</span> : null}
    </>
  )
}

export default function StepIndicator({
  steps,
  details = [],
  activeIndex = 0,
  label = 'Setup progress',
  onStepSelect,
}) {
  return (
    <ol
      className="step-indicator"
      aria-label={label}
      style={{ '--step-count': steps.length }}
    >
      {steps.map((step, index) => {
        const canSelect = typeof onStepSelect === 'function' && index < activeIndex
        const detail = details[index] || ''
        return (
          <li
            key={step}
            className={[
              'step-indicator__step',
              index === activeIndex ? 'is-active' : '',
              index < activeIndex ? 'is-complete' : '',
              canSelect ? 'is-selectable' : '',
            ].filter(Boolean).join(' ')}
            aria-current={index === activeIndex ? 'step' : undefined}
          >
            {canSelect ? (
              <button
                type="button"
                className="step-indicator__control"
                onClick={() => onStepSelect(index + 1)}
                aria-label={detail ? `Go back to ${step}, ${detail}` : `Go back to ${step}`}
              >
                <span className="step-indicator__number" aria-hidden="true">
                  <i className="fas fa-check" />
                </span>
                <StepMeta label={step} detail={detail} />
              </button>
            ) : (
              <>
                <span className="step-indicator__number" aria-hidden="true">
                  {index < activeIndex ? <i className="fas fa-check" /> : index + 1}
                </span>
                <StepMeta label={step} detail={detail} />
              </>
            )}
          </li>
        )
      })}
    </ol>
  )
}
